import styled from '@emotion/styled'

// Stile per il wrapper dei contenuti della BasePageTemplate
export const TabsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 60px;
`
